{
  "errors": {
    "notFound": {
      "title": "Page not found",
      "body": "The page you're looking for doesn't exist or has been moved.",
      "ctaDashboard": "Go to Dashboard",
      "ctaBack": "Go Back"
    },
    "serverError": {
      "title": "Something went wrong",
      "body": "An unexpected error occurred. Our team has been notified.",
      "ctaRetry": "Retry",
      "ctaDashboard": "Go to Dashboard"
    },
    "accessDenied": {
      "title": "Access denied",
      "body": "You don't have permission to view this page. Contact a Super Admin if you believe this is a mistake.",
      "ctaDashboard": "Go to Dashboard",
      "ctaSupport": "Contact Support"
    }
  },
  "common": {
    "skipToContent": "Skip to main content",
    "loading": "Loading…",
    "cancel": "Cancel"
  },
  "syncErrors": {
    "common": {
      "secondsAgo": "{{value}}s ago",
      "minutesAgo": "{{value}} min ago",
      "hoursAgo": "{{value}} h ago",
      "daysAgo": "{{value}} d ago",
      "loading": "Loading…",
      "refresh": "Refresh",
      "selectAll": "Select all",
      "deselect": "Deselect",
      "cancel": "Cancel",
      "close": "Close",
      "processing": "Processing…",
      "dash": "—"
    },
    "monitoring": {
      "title": "Sync Errors Monitoring",
      "rowsCount": "{{count}} rows",
      "rowsCountLoading": "{{count}} rows · loading…",
      "retentionBanner": "Sync errors older than 90 days are automatically purged (Phase 5 TTL retention policy).",
      "filters": {
        "platform": "Platform",
        "merchantId": "Merchant ID",
        "merchantIdPlaceholder": "ObjectId 24-hex",
        "errorType": "Error type",
        "errorTypePlaceholder": "error_type",
        "status": "Status",
        "retryGte": "Retry ≥",
        "dateFrom": "From date",
        "dateTo": "To date"
      },
      "platformOptions": {
        "all": "All platforms"
      },
      "statusOptions": {
        "all": "All statuses",
        "open": "Open",
        "retried": "Retried",
        "ignored": "Ignored"
      },
      "bulk": {
        "selected": "Selected",
        "syncErrorSuffix": "sync error",
        "retryCount": "Retry {{count}} rows"
      },
      "table": {
        "timestamp": "Timestamp",
        "platform": "Platform",
        "merchant": "Merchant",
        "errorType": "Error type",
        "errorCode": "Error code",
        "retry": "Retry",
        "status": "Status",
        "actions": "Actions",
        "empty": "No sync errors match the current filter.",
        "rowSelectAria": "Select sync error {{id}}"
      },
      "actions": {
        "retry": "Retry",
        "ignore": "Ignore"
      },
      "retryDialog": {
        "title": "Retry sync error?",
        "description": "Re-queue sync {{id}} ({{platform}}). The Phase 5 worker will retry on the original queue.",
        "confirm": "Retry"
      },
      "bulkRetryDialog": {
        "title": "Bulk retry?",
        "description": "Re-queue {{count}} sync errors? Each job will be re-queued on the original Phase 5 queue.",
        "confirm": "Retry {{count}} rows"
      },
      "ignoreDialog": {
        "title": "Ignore sync error?",
        "body": "Enter a reason for ignoring (10-500 chars). This action is audited.",
        "placeholder": "Example: Store has been closed, no need to retry…",
        "confirm": "Confirm ignore"
      },
      "toast": {
        "loadFailedTitle": "Failed to load sync errors",
        "loadFailedDesc": "Could not load the sync errors list",
        "retryQueuedTitle": "Sync error re-queued",
        "retryQueuedDesc": "Re-queued sync {{id}} (at {{time}}).",
        "retryFailedTitle": "Retry failed",
        "retryFailedDesc": "Retry failed",
        "bulkDoneTitle": "Bulk retry complete",
        "bulkDoneDesc": "Accepted {{accepted}}/{{total}}.",
        "bulkDoneDescRejected": "Accepted {{accepted}}/{{total}}, rejected {{rejected}}.",
        "bulkFailedTitle": "Bulk retry failed",
        "bulkFailedDesc": "Bulk retry failed",
        "reasonShortTitle": "Reason too short",
        "reasonShortDesc": "Please enter a reason of at least 10 characters.",
        "ignoredTitle": "Marked as ignored",
        "ignoredDesc": "Sync {{id}} status switched to \"ignored\".",
        "ignoreFailedTitle": "Ignore failed",
        "ignoreFailedDesc": "Ignore failed"
      }
    },
    "dlq": {
      "title": "Dead Letter Queue",
      "totalJobs": "{{count}} failed jobs",
      "totalJob": "{{count}} failed job",
      "filters": {
        "queue": "Queue",
        "dateFrom": "From date",
        "dateTo": "To date"
      },
      "queueOptions": {
        "all": "All queues",
        "invoiceGeneration": "Invoice generation",
        "taxBundle": "Tax bundle",
        "notificationEmail": "Notification email",
        "receiptGeneration": "Receipt generation",
        "pendingReminder": "Pending reminder"
      },
      "bulk": {
        "selected": "Selected",
        "jobSuffix": "job",
        "retryAll": "Retry all",
        "discardAll": "Discard all"
      },
      "table": {
        "queue": "Queue",
        "jobId": "Job ID",
        "failedAt": "Failed at",
        "attempts": "Attempts",
        "error": "Error",
        "actions": "Actions",
        "emptyFiltered": "No failed jobs match the current filter.",
        "empty": "No failed jobs in the DLQ.",
        "rowSelectAria": "Select job {{id}}"
      },
      "actions": {
        "view": "View",
        "retry": "Retry",
        "discard": "Discard"
      },
      "retryDialog": {
        "title": "Retry job?",
        "description": "Re-queue job {{id}} on queue {{queue}}?",
        "confirm": "Retry"
      },
      "discardDialog": {
        "title": "Discard job from DLQ",
        "body": "Job <strong>{{id}}</strong> ({{queue}}) will be permanently removed from the DLQ. The reason will be recorded in the audit log.",
        "reasonLabel": "Reason (1-500 chars)",
        "reasonPlaceholder": "e.g. Test job from staging, unrelated to real data",
        "errorTooShort": "Enter a reason (1-500 chars).",
        "errorTooLong": "Reason must be 500 chars or fewer.",
        "confirm": "Discard"
      },
      "bulkRetryDialog": {
        "title": "Bulk retry?",
        "description": "Re-queue {{count}} jobs? Each job uses its own Idempotency-Key and is audited.",
        "confirm": "Retry {{count}} jobs"
      },
      "bulkDiscardDialog": {
        "title": "Discard {{count}} jobs from DLQ",
        "body": "{{count}} jobs will be permanently removed. The reason will be reused for every audit log entry.",
        "reasonLabel": "Reason (1-500 chars)",
        "reasonPlaceholder": "e.g. Cleanup batch test data after staging deploy",
        "errorTooShort": "Enter a reason (1-500 chars).",
        "errorTooLong": "Reason must be 500 chars or fewer.",
        "confirm": "Discard {{count}} jobs"
      },
      "payloadDialog": {
        "title": "Payload — {{id}}",
        "queue": "Queue:",
        "attempts": "Attempts:",
        "failedAt": "Failed at:",
        "error": "Error:",
        "payloadJson": "Payload JSON"
      },
      "toast": {
        "endpointNotReadyTitle": "DLQ endpoint not ready",
        "endpointNotReadyDesc": "Backend Task 24 (BullMQ queue registration) has not been deployed — showing empty.",
        "loadFailedTitle": "Failed to load DLQ",
        "networkErrorTitle": "Network error — check your connection",
        "alreadyRetriedTitle": "Job already retried",
        "alreadyRetriedDesc": "Another admin just processed it — the list will refresh.",
        "retryFailedTitle": "Retry failed",
        "retryQueuedTitle": "Job re-queued",
        "retryQueuedDesc": "Job {{id}} was re-queued on {{queue}}.",
        "discardFailedTitle": "Discard failed",
        "discardedTitle": "Job discarded",
        "discardedDesc": "Job {{id}} was removed from the DLQ and recorded in the audit log.",
        "bulkRetryDoneTitle": "Bulk retry complete",
        "bulkRetryDoneDesc": "Succeeded {{success}}/{{total}}.",
        "bulkRetryDoneDescFailed": "Succeeded {{success}}/{{total}}, failed {{failed}}.",
        "bulkDiscardDoneTitle": "Bulk discard complete",
        "bulkDiscardDoneDesc": "Discarded {{success}}/{{total}}.",
        "bulkDiscardDoneDescFailed": "Discarded {{success}}/{{total}}, failed {{failed}}."
      }
    },
    "dlqDetail": {
      "title": "Sync Errors DLQ",
      "rowsCount": "{{count}} rows (page {{page}})",
      "retentionBanner": "Sync errors are automatically purged after 90 days (inherits the Phase 5 retention policy).",
      "exportCsv": "Export CSV",
      "filters": {
        "storeId": "Store ID",
        "storeIdPlaceholder": "ObjectId 24-hex",
        "platform": "Platform",
        "errorType": "Error type",
        "errorTypePlaceholder": "error_class",
        "retried": "Retried",
        "dateFrom": "From date",
        "dateTo": "To date"
      },
      "platformOptions": {
        "all": "All platforms"
      },
      "retriedOptions": {
        "all": "All",
        "no": "Not retried",
        "yes": "Retried"
      },
      "statusOptions": {
        "pending": "Pending",
        "retrying": "Retrying",
        "resolved": "Resolved",
        "permanentlyFailed": "Permanently failed"
      },
      "bulk": {
        "selected": "Selected",
        "syncErrorSuffix": "sync error",
        "retryCount": "Retry {{count}} rows"
      },
      "table": {
        "store": "Store",
        "platform": "Platform",
        "errorType": "Error type",
        "error": "Error",
        "retry": "Retry",
        "status": "Status",
        "timestamp": "Timestamp",
        "actions": "Actions",
        "empty": "No sync errors match the current filter.",
        "rowSelectAria": "Select sync error {{id}}"
      },
      "actions": {
        "retry": "Retry"
      },
      "pagination": {
        "info": "Page {{page}} · {{count}} rows",
        "prev": "Previous",
        "next": "Next"
      },
      "retryDialog": {
        "title": "Retry sync error?",
        "description": "Re-queue the sync job for store {{store}}? The Phase 5 worker will retry on the original queue.",
        "confirm": "Retry"
      },
      "bulkRetryDialog": {
        "title": "Bulk retry?",
        "description": "Re-queue {{count}} sync errors? Each job will be re-queued on the original Phase 5 queue.",
        "confirm": "Retry {{count}} rows"
      },
      "toast": {
        "loadFailedTitle": "Failed to load sync errors",
        "loadFailedDesc": "Could not load the sync errors list",
        "retryQueuedTitle": "Sync error re-queued",
        "retryQueuedDesc": "Re-queued job {{id}} ({{count}} jobs enqueued).",
        "noLongerInDlqTitle": "Sync error no longer in DLQ",
        "noLongerInDlqDesc": "Another admin may have already retried it — the list will refresh.",
        "retryFailedTitle": "Retry failed",
        "retryFailedDesc": "Retry failed",
        "bulkDoneTitle": "Bulk retry complete",
        "bulkDoneDesc": "Succeeded {{success}}/{{total}}.",
        "bulkDoneDescFailed": "Succeeded {{success}}/{{total}}, failed {{failed}}.",
        "bulkFailedTitle": "Bulk retry failed",
        "bulkFailedDesc": "Bulk retry failed",
        "exportDoneTitle": "CSV exported",
        "exportDoneDesc": "{{count}} rows downloaded.",
        "exportFailedTitle": "Export failed",
        "exportFailedDesc": "Export failed"
      }
    },
    "reports": {
      "header": {
        "title": "Sync Error Reports",
        "subtitle": "Sync error reports grouped by source store / entity type / status. Single-row manual retry; DLQ ops live on the Monitoring page.",
        "loading": "Loading…",
        "refresh": "Refresh"
      },
      "retention": {
        "default": "Sync error reports are automatically purged after 90 days (inherits the Phase 5 retention policy).",
        "withPolicy": "Sync error reports are automatically purged after {{policy}}."
      },
      "filter": {
        "source": "Source",
        "entity": "Entity",
        "resolved": "Resolution status",
        "from": "From date",
        "to": "To date",
        "search": "Search",
        "searchPlaceholder": "error_code or message text",
        "clear": "Clear filters"
      },
      "sourceOption": {
        "all": "All sources"
      },
      "entityOption": {
        "all": "All entities",
        "order": "Orders",
        "product": "Products",
        "inventory": "Inventory",
        "customer": "Customers"
      },
      "resolvedOption": {
        "all": "All",
        "no": "Unresolved",
        "yes": "Resolved"
      },
      "column": {
        "timestamp": "Timestamp",
        "source": "Source",
        "entity": "Entity",
        "store": "Store",
        "merchant": "Merchant",
        "errorCode": "Error code",
        "message": "Message",
        "retry": "Retry",
        "status": "Status",
        "action": "Actions"
      },
      "status": {
        "open": "Open",
        "retried": "Retried",
        "ignored": "Ignored",
        "resolved": "Resolved"
      },
      "empty": "No sync errors match the current filter.",
      "retry": "Retry",
      "pagination": {
        "summary": "Page {{page}} · {{count}} rows",
        "prev": "Previous",
        "next": "Next"
      },
      "confirm": {
        "title": "Retry sync error?",
        "description": "Re-queue the sync job for {{target}} ({{errorCode}})? The Phase 5 worker will retry on the original queue.",
        "label": "Retry"
      },
      "relative": {
        "secondsAgo": "{{count}}s ago",
        "minutesAgo": "{{count}} min ago",
        "hoursAgo": "{{count}} h ago",
        "daysAgo": "{{count}} d ago"
      },
      "toast": {
        "loadFailedTitle": "Failed to load sync error reports",
        "loadFailedFallback": "Failed to load sync error reports",
        "retrySuccessTitle": "Sync error re-queued",
        "retrySuccessDescription": "Re-queued job {{jobId}} ({{count}} job enqueued).",
        "notInDlqTitle": "Sync error no longer in DLQ",
        "notInDlqDescription": "Another admin may have already retried it — the list will refresh.",
        "retryFailedTitle": "Retry failed",
        "retryFailedFallback": "Retry failed"
      }
    }
  },
  "payouts": {
    "queue": {
      "page": {
        "title": "Vendor Payouts Queue",
        "subtitle": "Review and reconcile vendor payout requests — single approve per row."
      },
      "tab": {
        "all": "All",
        "pending": "Pending",
        "processing": "Processing",
        "completed": "Completed",
        "failed": "Failed"
      },
      "summary": {
        "totalPending": "Total Pending",
        "approvedThisMonth": "Approved This Month"
      },
      "chart": {
        "title": "Status distribution (visible rows)",
        "countSuffix": "payouts",
        "noData": "No data yet."
      },
      "filter": {
        "ariaLabel": "Filter payout status",
        "preKycChip": "Pre-KYC pending",
        "loading": "Loading…",
        "results": "{{count}} results"
      },
      "column": {
        "vendor": "Vendor",
        "net": "Net",
        "gateway": "Gateway",
        "status": "Status",
        "createdAt": "Created",
        "action": "Actions"
      },
      "list": {
        "loading": "Loading payouts…",
        "errorTitle": "Could not load the payouts list.",
        "retry": "Try again",
        "emptyPreKyc": "No Pre-KYC vendors in this status.",
        "emptyDefault": "No payouts match."
      },
      "row": {
        "preKycTitle": "Pre-KYC pending — payout blocked",
        "preKycBadge": "Pre-KYC ({{kycStatus}})",
        "vendorPrefix": "vendor: {{vendorId}}",
        "failedNoRetry": "No auto-retry. Earnings rolled back to Available.",
        "failedReason": "Reason: {{reason}}",
        "approve": "Approve",
        "reject": "Reject",
        "markTransferred": "Mark Transferred",
        "closed": "Closed — no action required"
      },
      "relative": {
        "justNow": "just now",
        "minutes": "{{count}} min ago",
        "hours": "{{count}} h ago",
        "days": "{{count}} d ago"
      }
    },
    "approve": {
      "ariaLabel": "Approve payout — {{vendor}}",
      "title": "Approve payout — {{vendor}}",
      "bodyLead": "Payout will move from",
      "bodyTo": "to",
      "bodyTail": ". Vendor KYC will be re-checked on the server.",
      "bodyFrom": "Pending",
      "bodyDest": "Processing",
      "amountLabel": "Amount (net)",
      "gatewayLabel": "Gateway",
      "cancel": "Cancel",
      "confirm": "Approve",
      "submitting": "Approving…",
      "toast": {
        "successTitle": "Payout approved",
        "successDescription": "{{vendor}} moved to Processing.",
        "kycBlockedTitle": "Vendor has not completed KYC",
        "kycBlockedFallback": "Payout blocked — vendor must complete KYC first.",
        "stateChangedTitle": "Payout status changed",
        "stateChangedFallback": "Payout is no longer Pending — the list will reload.",
        "approveFailedTitle": "Could not approve payout",
        "networkErrorTitle": "Network error",
        "networkErrorFallback": "Check your connection and try again.",
        "selfApprovalTitle": "You cannot approve this payout",
        "selfApprovalDescription": "You created this withdrawal on the vendor’s behalf, so another admin must approve it."
      }
    },
    "reject": {
      "ariaLabel": "Reject payout — {{vendor}}",
      "title": "Reject payout — {{vendor}}",
      "bodyLead": "Earnings will",
      "bodyBold": "roll back",
      "bodyTail": "to the vendor's Available wallet (no auto-retry, vendor must create a new request).",
      "reasonLabel": "Rejection reason",
      "reasonRequired": "*",
      "reasonPlaceholder": "e.g. Bank account name does not match KYC document.",
      "reasonHelp": "Shown to vendor. 10-500 chars.",
      "errorMin": "Reason required (min 10 chars).",
      "errorMax": "Reason too long (max 500 chars).",
      "cancel": "Cancel",
      "confirm": "Reject",
      "submitting": "Rejecting…",
      "toast": {
        "successTitle": "Payout rejected",
        "successDescription": "{{vendor}}'s earnings rolled back to Available wallet.",
        "stateChangedTitle": "Payout status changed",
        "stateChangedFallback": "Payout is no longer Pending — the list will reload.",
        "rejectFailedTitle": "Could not reject payout",
        "networkErrorTitle": "Network error",
        "networkErrorFallback": "Check your connection and try again."
      }
    }
  },
  "orderCancel": {
    "modal": {
      "title": "Cancel order",
      "descWithNumberLead": "Order",
      "descWithNumberMiddle": "— value",
      "descWithNumberTail": ". Cancellation is a dual decision: merchant refund (1) and vendor compensation (2) are independent.",
      "descDefault": "Cancellation is a dual decision: merchant refund (1) and vendor compensation (2) are independent."
    },
    "mode": {
      "legend": "Cancel mode",
      "softTitle": "Soft cancel",
      "softHelp": "Order not in production, vendor not charged — cancel immediately",
      "forceTitle": "Force cancel",
      "forceHelp": "Order in/post-production — consider vendor compensation"
    },
    "refund": {
      "legend": "(1) Merchant refund",
      "full": "Full refund ({{value}})",
      "partial": "Partial refund",
      "none": "No refund",
      "partialLabel": "Refund amount (cents — integer USD cents)",
      "partialPlaceholder": "1..{{max}}",
      "partialError": "Must be greater than 0 and not exceed {{max}}"
    },
    "compensation": {
      "legend": "(2) Vendor compensation",
      "enableTitle": "Compensate vendor from platform budget",
      "enableHelp": "Compensation is paid from the platform, not deducted from the merchant.",
      "noVendor": " — this order has no vendor assigned, compensation unavailable.",
      "amountLabel": "Compensation amount (cents)",
      "amountPlaceholder": "e.g. 5000 (= $50.00)",
      "reasonLabel": "Compensation reason (1..{{max}} chars)",
      "reasonPlaceholder": "e.g. vendor finished printing, fault is not the vendor's"
    },
    "reason": {
      "legend": "Cancellation reason",
      "codeLabel": "Reason code",
      "detailLabel": "Detailed reason (>= {{min}} chars)",
      "remainingChars": "{{count}} more characters required",
      "valid": "Valid",
      "codes": {
        "CHANGED_MIND": "Customer changed mind",
        "WRONG_ADDRESS": "Wrong address",
        "WRONG_PRODUCT": "Wrong product",
        "WRONG_ARTWORK": "Wrong artwork",
        "DUPLICATE_ORDER": "Duplicate order",
        "CUSTOMER_REQUEST": "Customer request",
        "OTHER": "Other (enter reason)",
        "VENDOR_FAILURE": "Vendor failure",
        "FRAUD_SUSPECTED": "Suspected fraud",
        "SYSTEM_ERROR": "System error",
        "POLICY_VIOLATION": "Policy violation"
      }
    },
    "dualApproval": {
      "title": "Two-admin approval required (Dual approval)",
      "reasonRefund": "Total merchant refund ({{refund}}) exceeds threshold {{threshold}}",
      "reasonForce": "Force cancelling an order ({{value}}) exceeds threshold {{threshold}}",
      "footnote": "The request will be parked and a second admin must approve."
    },
    "errors": {
      "network": "Network error - check connection"
    },
    "cta": {
      "close": "Close",
      "submitting": "Submitting…",
      "submitApproval": "Submit for approval",
      "submitForce": "Force cancel",
      "submitDefault": "Cancel order"
    }
  },
  "creditEditor": {
    "titleCreate": "Grant new credit",
    "titleEdit": "Edit credit",
    "field": {
      "email": {
        "label": "Merchant email"
      },
      "description": {
        "label": "Description (optional)",
        "placeholder": "Example: Q2 promotional credit line"
      },
      "limit": {
        "label": "Limit (USD)",
        "editHint": "(increase-only — min ${{min}})",
        "required": "Limit is required",
        "minError": "Minimum ${{min}}",
        "centsHint": "= {{cents}} cents"
      },
      "period": {
        "label": "Period (days)",
        "modePreset": "Preset",
        "modeCustom": "Custom",
        "dayUnit": "{{count}} days",
        "minError": "Minimum 1 day",
        "maxError": "Maximum 3650 days"
      },
      "startDate": {
        "label": "Start date",
        "immutableHint": "(immutable)",
        "required": "Start date is required",
        "invalid": "Start date is invalid"
      }
    },
    "options": {
      "legend": "Options",
      "notify": "Notify merchant when credit is granted (notify)",
      "expiryReminder": "Enable expiry reminder 7 + 1 days (expiry reminder)",
      "autoLock": "Lock order creation when overdue (auto-lock overdue)",
      "autoReset": "Auto-restore when balance is clear + expired (auto-reset)",
      "remindAt": "Remind when spend hits threshold (remind-at-amount)",
      "remindAtThreshold": "Threshold (USD)",
      "remindAtMinError": "Minimum $1"
    },
    "cta": {
      "cancel": "Cancel",
      "create": "Grant credit",
      "save": "Save changes",
      "saving": "Saving…"
    },
    "toast": {
      "invalidDataTitle": "Invalid data",
      "invalidDataFallback": "Please review the form",
      "createSuccess": "Credit granted",
      "createFail": "Failed to grant credit",
      "unknownError": "Unknown error",
      "overdueTitle": "Cannot grant credit",
      "overdueDesc": "Merchant is overdue — cannot grant a new credit",
      "missingCreditId": "Missing creditId (edit mode)",
      "noChanges": "No changes to save",
      "editSuccess": "Credit updated",
      "editFail": "Failed to update credit"
    }
  },
  "systemHealth": {
    "title": "System Health",
    "superAdminAria": "Super Admin only",
    "refreshing": "Refreshing…",
    "subtitle": "Real-time monitoring dashboard — auto-refreshes every 10 seconds. Shows system resources, API performance, service status, alerts, and recent backups.",
    "metric": {
      "windowOption": {
        "10m": "10 min",
        "1h": "1 hour",
        "6h": "6 hours"
      }
    },
    "section": {
      "resources": "System resources",
      "infra": "Infrastructure",
      "apiPerf": "API performance",
      "services": "Service status",
      "alerts": "Alert rules",
      "backup": "Backup"
    },
    "alertRule": {
      "label": {
        "cpuHigh": "CPU high",
        "memoryHigh": "Memory high",
        "diskHigh": "Disk high",
        "apiP95High": "API p95 slow",
        "redisMemoryHigh": "Redis memory high",
        "dbConnectionsHigh": "DB connections high"
      },
      "saveCta": "Save thresholds",
      "saving": "Saving…",
      "toast": {
        "saveSuccessTitle": "Alert thresholds saved",
        "saveSuccessDesc": "Applied on the collector's next evaluation.",
        "saveFailTitle": "Cannot save thresholds"
      },
      "footnote": "Default thresholds: 80/95/100. Changes are persisted to system_settings.security.anomaly_rules and applied on the next collector pass.",
      "activeSincePrefix": "Since {{time}}"
    },
    "backup": {
      "recentTitle": "Recent backups (7 days)",
      "recentDesc": "Auto-refreshes every 10 seconds with the other metrics.",
      "column": {
        "jobId": "Job ID",
        "scope": "Scope",
        "start": "Started",
        "end": "Finished",
        "status": "Status",
        "size": "Size",
        "download": "Download"
      },
      "empty": {
        "loading": "Loading backup history…",
        "none": "No backups in the last 7 days."
      },
      "status": {
        "succeeded": "Succeeded",
        "running": "Running",
        "failed": "Failed"
      },
      "downloadLink": "Download",
      "triggerCta": "Trigger backup",
      "unavailableHint": "Automated backup is not available yet (worker not implemented).",
      "dialog": {
        "title": "Trigger manual backup",
        "scopeLabel": "Scope",
        "reasonLabel": "Reason",
        "reasonPlaceholder": "Example: Pre-release snapshot phase 8.3",
        "reasonHint": "Minimum 10 characters — for audit log.",
        "cancel": "Cancel",
        "enqueueCta": "Enqueue backup",
        "enqueuing": "Enqueuing…",
        "scopeOption": {
          "db": "Database",
          "files": "Files",
          "full": "Full (DB + Files)"
        }
      },
      "toast": {
        "enqueueSuccessTitle": "Backup enqueued",
        "enqueueSuccessDescPrefix": "Job {{jobId}}",
        "enqueueFailTitle": "Cannot enqueue backup",
        "reasonRequiredTitle": "Backup reason required",
        "reasonRequiredDesc": "Minimum 10 characters — for audit log."
      }
    },
    "service": {
      "restartTitlePrefix": "Restart {{svc}}",
      "restartDesc": "API restart will be wired in the Phase 9 ops surface. For now, the request is just recorded."
    }
  },
  "orderWarnings": {
    "title": "Order Warnings",
    "subtitle": "Order warnings by merchant/vendor (Late production / Late shipping / Quality issue). Drill into the order detail to resolve.",
    "refreshCta": "Refresh",
    "refreshing": "Loading…",
    "filter": {
      "severityLabel": "Severity",
      "ageLabel": "Age",
      "statusLabel": "Status",
      "categoryLabel": "Category",
      "vendorIdLabel": "Vendor ID",
      "merchantIdLabel": "Merchant ID",
      "fromLabel": "From",
      "toLabel": "To",
      "searchLabel": "Search",
      "objectIdPlaceholder": "ObjectId 24-hex",
      "searchPlaceholder": "Order # or warning content",
      "clearCta": "Clear filters"
    },
    "severityOption": {
      "all": "All severities",
      "high": "High",
      "medium": "Medium",
      "low": "Low"
    },
    "severityShort": {
      "high": "High",
      "medium": "Med",
      "low": "Low"
    },
    "ageOption": {
      "all": "All ages",
      "lt24h": "< 24 hours",
      "1to3d": "1 - 3 days",
      "gt3d": "> 3 days"
    },
    "statusOption": {
      "all": "All statuses",
      "open": "Open",
      "acknowledged": "Acknowledged",
      "resolved": "Resolved"
    },
    "categoryOption": {
      "all": "All categories",
      "lateProduction": "Late production",
      "lateShipping": "Late shipping",
      "qualityIssue": "Quality issue"
    },
    "column": {
      "order": "Order #",
      "category": "Category",
      "merchant": "Merchant",
      "vendor": "Vendor",
      "severity": "Severity",
      "age": "Age",
      "status": "Status",
      "content": "Content",
      "actions": "Actions"
    },
    "empty": "No warnings match the filters.",
    "drillCta": "Open order",
    "pageInfo": "Page {{page}} · {{count}} rows",
    "pagePrev": "Previous",
    "pageNext": "Next",
    "ageUnit": {
      "hours": "{{count}} hours",
      "daysShort": "{{days}}d {{hours}}h",
      "daysFull": "{{count}} days"
    },
    "toast": {
      "loadFailTitle": "Failed to load order warnings",
      "loadFailFallback": "Failed to load order warnings"
    }
  },
  "gateway": {
    "settings": {
      "toast": {
        "savedTitle": "Gateway configuration saved",
        "saveFailedTitle": "Could not save configuration",
        "webhookRegeneratedTitle": "Webhook secret regenerated",
        "webhookRegeneratedDesc": "Update the new secret in the gateway dashboard so webhooks continue to verify.",
        "webhookRegenerateFailedTitle": "Could not regenerate webhook",
        "webhookCopiedTitle": "Webhook URL copied"
      },
      "loading": "Loading {{gateway}} configuration…",
      "loadFailedPrefix": "Could not load:",
      "tierLockedTier1": "Tier 1 gateway — hot-swap is not supported.",
      "tierLockedTier2": "Tier 2 gateway — hot-swap is not supported.",
      "savingShort": "Saving…",
      "pauseDialog": {
        "titlePause": "Pause gateway {{gateway}}?",
        "titleResume": "Resume gateway {{gateway}}?",
        "descPause": "The BullMQ queue will pause and the merchant portal will show the \"Maintenance\" badge. A reason (≥{{min}} characters) is required for the audit log.",
        "descResume": "The BullMQ queue will resume automatically. Notes are optional.",
        "reasonLabelPause": "Reason (≥{{min}} characters)",
        "reasonLabelResume": "Notes (optional)",
        "reasonPlaceholderPause": "e.g. Suspected fraud spike — holding for investigation",
        "reasonPlaceholderResume": "e.g. Health check has been stable for 5 minutes",
        "reasonTooShort": "Reason must be at least {{min}} characters (currently {{count}}).",
        "cancel": "Cancel",
        "processing": "Processing…",
        "confirmPause": "Pause",
        "confirmResume": "Resume"
      },
      "pauseBanner": "Queue is paused — merchant portal shows the \"Maintenance\" badge. No auto-switch to another gateway.",
      "card": {
        "auditNotice": "Each reveal is written to the audit log and auto-hides after 30 seconds.",
        "statusHeading": "Status"
      },
      "toastP8": {
        "pausedTitle": "Paused {{gateway}}",
        "resumedTitle": "Resumed {{gateway}}",
        "networkError": "Network error — check your connection.",
        "alreadyPausedTitle": "Gateway already paused",
        "pauseFailedTitle": "Could not pause",
        "notPausedTitle": "Gateway is not in paused state",
        "resumeFailedTitle": "Could not resume"
      },
      "panel": {
        "statusFilterLabel": "Status",
        "statusFilterAll": "All",
        "loadingList": "Loading gateway list…",
        "loadFailedPrefix": "Could not load:",
        "loadFailedUnknown": "unknown error",
        "empty": "No payment gateway in this status yet."
      }
    }
  },
  "emailTemplate": {
    "variables": {
      "errorKeyEmpty": "Variable key cannot be empty.",
      "errorKeyPattern": "Key may only contain lowercase letters, digits, underscores (a-z, 0-9, _).",
      "errorKeyDuplicate": "Key \"{{key}}\" already exists.",
      "errorDescriptionEmpty": "Variable description cannot be empty.",
      "hint": "Variable names render as <code>{{syntax}}</code> when the email is sent.",
      "empty": "No variables yet — add one below.",
      "insert": "Insert",
      "remove": "Remove",
      "defaultLabel": "Default",
      "addLegend": "Add new variable",
      "addButton": "Add variable"
    },
    "editor": {
      "validationNameShort": "Template name must be at least 2 characters.",
      "validationSubjectEnShort": "Subject (EN) must be at least 2 characters.",
      "validationBodyEnShort": "Body (EN) must be at least 10 characters.",
      "createdToast": "Template created",
      "savedToast": "Template saved",
      "saveFailedToast": "Save failed",
      "previewWarnUnsavedTitle": "Save template before previewing",
      "previewPopupBlockedTitle": "Browser blocked the new window",
      "previewPopupBlockedDesc": "Enable pop-ups for the admin domain and try again.",
      "previewFailedTitle": "Preview failed",
      "translateWarnUnsavedTitle": "Save template before translating",
      "translateWarnSameLangTitle": "Choose a target language other than EN",
      "translateDoneTitle": "Translated to {{target}}",
      "translateDoneDesc": "{{count}} fields — translator {{translator}}",
      "translateFailedTitle": "Translation failed",
      "headerTitleNew": "Create Email Template",
      "headerTitleEdit": "Edit Email Template",
      "headerSubtitle": "TipTap WYSIWYG · i18n EN / VI / FR · variables render as <code>{{syntax}}</code> · Google Translate bulk EN→VI.",
      "backLabel": "Back to Email Templates",
      "previewing": "Rendering…",
      "translating": "Translating…",
      "translateButton": "Translate EN → VI",
      "savingShort": "Saving…",
      "createShort": "Create",
      "saveShort": "Save",
      "loading": "Loading…",
      "nameLabel": "Template name",
      "categoryLabel": "Category",
      "bodyPlaceholder": "Compose the email body…",
      "previewTextPlaceholder": "Shown in inbox preview",
      "previewTextHelp": "Shown next to the subject in the inbox (Gmail, Outlook)."
    }
  },
  "wallet": {
    "adjustment": {
      "reasonOption": {
        "penalty": "Penalty",
        "qualityIssue": "Quality Issue",
        "return": "Return",
        "bonus": "Bonus",
        "correction": "Balance Correction",
        "other": "Other"
      },
      "title": "Adjust vendor wallet balance",
      "descriptionWithName": "Create a manual adjustment for vendor <strong>{{vendor}}</strong>'s wallet. Every adjustment is audited; amounts > $10,000 USD require a second admin to approve.",
      "descriptionGeneric": "Create a manual adjustment for the vendor wallet. Every adjustment is audited; amounts > $10,000 USD require a second admin to approve.",
      "typeLegend": "Adjustment type",
      "typeCredit": "+ Credit (Add to wallet)",
      "typeDebit": "− Debit (Remove from wallet)",
      "amountLabel": "Amount (USD)",
      "amountInvalid": "Invalid amount — enter USD with up to 2 decimal places, greater than 0.",
      "reasonGroupLabel": "Reason group",
      "reasonDetailLabel": "Detailed reason",
      "reasonDetailMinHint": "(minimum {{min}} characters)",
      "reasonDetailPlaceholder": "Describe the reason in detail — saved to the audit log",
      "reasonDetailRemaining": "Need {{count}} more character(s)",
      "linkedOrderLabel": "Linked Order ID",
      "linkedOrderOptionalHint": "(optional)",
      "linkedOrderPlaceholder": "Order ObjectId — leave blank if not tied to a specific order",
      "linkedOrderInvalid": "Order ID must be a 24-character hex string.",
      "previewHeading": "Balance preview",
      "negativeWarning": "Post-adjustment balance would be negative — not allowed. Lower the amount or switch to Credit.",
      "dualApprovalLabel": "Dual approval required:",
      "dualApprovalBodyPre": "This amount exceeds the $10,000 USD threshold. The request will be held in",
      "dualApprovalBodyEm": "Awaiting peer approval",
      "dualApprovalBodyPost": "until another admin approves it from the queue.",
      "auditNotice": "Every wallet adjustment is recorded in <code>audit_logs</code> with the operator's identity, IP, timestamp, and reason — for auditability and reversibility.",
      "cancel": "Cancel",
      "submitting": "Submitting…",
      "submitDualApproval": "Send for approval",
      "submitApply": "Confirm adjustment"
    }
  },
  "adminMgmt": {
    "page": {
      "title": "Admin Management",
      "saOnlyBadge": "SA only",
      "description": "Create, change roles, deactivate staff accounts. Bootstrap 2FA is required before a new account can sign in.",
      "denied": "Only Super Admins can access this page."
    },
    "role": {
      "all": "All roles",
      "superadmin": "Super Admin",
      "admin": "Admin",
      "supportAdmin": "Support Admin",
      "accountant": "Accountant",
      "saler": "Saler",
      "manager": "Manager"
    },
    "status": {
      "all": "All statuses",
      "active": "Active",
      "disabled": "Disabled"
    },
    "mfa": {
      "enrolled": "Enabled",
      "notEnrolled": "Not yet"
    },
    "column": {
      "name": "Name",
      "email": "Email",
      "role": "Role",
      "status": "Status",
      "mfa": "MFA",
      "lastLogin": "Last login",
      "createdAt": "Created at",
      "actions": "Actions"
    },
    "filter": {
      "label": "Filters",
      "role": "Role",
      "status": "Status",
      "search": "Search by email/name",
      "searchPlaceholder": "email@printway.work"
    },
    "action": {
      "createAdmin": "Create admin",
      "deactivate": "Deactivate",
      "reset2fa": "Reset 2FA",
      "enable2fa": "Enable 2FA"
    },
    "tooltip": {
      "selfDeactivate": "You cannot deactivate your own account",
      "needOneSa": "At least one active Super Admin is required",
      "alreadyDisabled": "Account is already disabled",
      "deactivateAccount": "Deactivate account",
      "reactivateBefore2fa": "Account is disabled — re-activate before setting up 2FA",
      "reset2faAdmin": "Reset 2FA for this admin",
      "enable2faRequired": "Enable 2FA (required before activation)",
      "superAdmin": "Super Admin"
    },
    "banner": {
      "lastSa": "At least one active Super Admin is required. Promote another Super Admin before deactivating or demoting the current one.",
      "selfDemote": "You cannot demote yourself while you are the only Super Admin. Promote another Super Admin first."
    },
    "deactivateDialog": {
      "title": "Deactivate {{email}}",
      "description": "The account will be logged out of every open session. This action is recorded in the audit log with the reason below.",
      "reasonLabel": "Reason (at least 10 characters)",
      "cancel": "Cancel",
      "confirm": "Deactivate",
      "submitting": "Processing…"
    },
    "toast": {
      "deactivateSuccessTitle": "Account deactivated",
      "deactivateSuccessDescription": "Revoked {{count}} sign-in sessions.",
      "deactivateErrorTitle": "Could not deactivate",
      "twofaSuccessTitle": "2FA enabled successfully",
      "twofaSuccessDescription": "Account is ready to sign in."
    },
    "list": {
      "errorFallback": "Could not load the admin list.",
      "empty": "No admins match the current filter."
    }
  },
  "imapParser": {
    "page": {
      "title": "IMAP Parser Monitoring"
    },
    "tab": {
      "gateways": "Gateways",
      "logs": "Parse Logs"
    },
    "gateway": {
      "listTitle": "Gateway list",
      "count": "{{count}} gateway",
      "refresh": "Refresh",
      "refreshing": "Loading…",
      "newGateway": "+ New gateway",
      "empty": "No IMAP gateways yet.",
      "active": "Active",
      "inactive": "Inactive",
      "errorCount": "{{count}} errors",
      "pollSuffix": "poll {{seconds}}s"
    },
    "editor": {
      "titleEdit": "Edit: {{label}}",
      "titleCreate": "Create new gateway",
      "defaultLabel": "gateway",
      "host": "Host",
      "port": "Port",
      "email": "Email",
      "emailPlaceholder": "topup-bot@printway.work",
      "password": "Password",
      "passwordKeepHintExisting": "(leave blank to keep current)",
      "passwordKeepHintBlank": "(leave blank to keep)",
      "passwordPlaceholderEdit": "••••••••",
      "passwordPlaceholderCreate": "app-specific-password",
      "pollInterval": "Poll interval (seconds ≥ {{min}})",
      "inboxFolder": "Inbox folder",
      "regexSender": "Regex — Sender filter",
      "regexTransaction": "Regex — Transaction ID",
      "regexAmount": "Regex — Amount",
      "active": "Active",
      "save": "Save changes",
      "create": "Create gateway",
      "saving": "Saving…",
      "testConnection": "Test connection",
      "testing": "Testing…",
      "reset": "Reset",
      "delete": "Delete"
    },
    "validation": {
      "required": "Required",
      "portRange": "Port 1-65535",
      "emailInvalid": "Email is invalid",
      "passwordMin": "Password ≥ 8 characters",
      "passwordMinOptional": "Password ≥ 8 characters (or leave blank to keep current)",
      "pollRange": "Poll interval must be ≥ {{min}}s and ≤ {{max}}s"
    },
    "testConnection": {
      "resultMessageCount": "{{count}} emails in inbox.",
      "lastPrefix": "Last:"
    },
    "parseTest": {
      "title": "Parse test (paste sample email)",
      "samplePlaceholder": "From: noreply@vietcombank.com.vn\\nSubject: Payment confirmation\\nTransaction TXN12345 — amount: 1,000,000…",
      "run": "Run parse test",
      "running": "Parsing…",
      "senderMatch": "Sender match:",
      "senderYes": "Yes",
      "senderNo": "No",
      "transactionId": "Transaction ID:",
      "amount": "Amount:"
    },
    "logs": {
      "gatewayId": "Gateway ID",
      "gatewayIdPlaceholder": "ObjectId 24-hex",
      "status": "Status",
      "statusAll": "All",
      "from": "From date",
      "to": "To date",
      "refresh": "Refresh",
      "refreshing": "Loading…",
      "column": {
        "timestamp": "Timestamp",
        "gateway": "Gateway",
        "sender": "Sender",
        "amount": "Amount",
        "txnId": "Txn ID",
        "status": "Status",
        "topupId": "Topup ID"
      },
      "empty": "No parse logs match the current filter."
    },
    "deleteDialog": {
      "title": "Delete IMAP gateway?",
      "description": "Delete gateway {{email}}? Polling will stop immediately; this is a soft-delete and is fully auditable.",
      "confirm": "Delete"
    },
    "toast": {
      "loadGatewaysErrorTitle": "Could not load IMAP gateways",
      "loadGenericErrorDescription": "Could not load the list",
      "loadLogsErrorTitle": "Could not load parse logs",
      "createSuccessTitle": "IMAP gateway created",
      "updateSuccessTitle": "IMAP gateway updated",
      "saveErrorTitle": "Save failed",
      "saveErrorDescription": "Save failed",
      "deleteSuccessTitle": "IMAP gateway deleted",
      "deleteErrorTitle": "Delete failed",
      "deleteErrorDescription": "Delete failed",
      "needSaveTitle": "Save first",
      "needSaveDescription": "Please save the gateway before testing the connection.",
      "testConnectionSuccessTitle": "Test connection succeeded",
      "testConnectionErrorTitle": "Test connection failed",
      "testConnectionErrorDescription": "Could not connect",
      "sampleTooShortTitle": "Sample too short",
      "sampleTooShortDescription": "Sample email must be ≥ {{min}} characters.",
      "missingRegexTitle": "Missing regex patterns",
      "missingRegexDescription": "Please fill in all 3 regex patterns.",
      "parseMatchTitle": "Sample matched sender",
      "parseNoMatchTitle": "Sample did NOT match sender",
      "parseMatchDescription": "Txn={{txn}}, Amount={{amount}}",
      "parseNoMatchDescription": "Regex sender_filter did not match the sample.",
      "parseErrorTitle": "Parse test failed",
      "parseErrorDescription": "Could not parse"
    }
  },
  "security": {
    "page": {
      "title": "System Settings — Security",
      "description": "Configure IP blacklist, anomaly detection, Emergency Mode and 2FA for admin roles. Every change is audited and emits a WS system.* event.",
      "readOnlyNotice": "You are in read-only mode. The {{permission}} permission is required to edit.",
      "loadError": "Could not load security settings.",
      "saveErrorFallback": "Could not save settings."
    },
    "form": {
      "ariaTitle": "Security policy settings"
    },
    "twofa": {
      "legend": "2FA — required by role",
      "description": "Enable to force users with that role to enrol 2FA within the grace period. After the grace period, sign-in is blocked until enrolment completes.",
      "role": {
        "superadmin": "Super Admin",
        "admin": "Admin",
        "support": "Support",
        "accountant": "Accountant"
      },
      "graceDays": "Grace period (days)"
    },
    "password": {
      "legend": "Password policy",
      "minLength": "Minimum length",
      "expiryDays": "Expires after (days)",
      "historyCount": "History (cannot reuse last N)",
      "requireComplexity": "Require complexity (letters + digits + special characters)"
    },
    "anomaly": {
      "legend": "Anomaly detection — thresholds",
      "failedLoginThreshold": "Failed login attempts",
      "failedLoginWindow": "Time window (minutes)",
      "failedLoginBlockHours": "Block duration (hours)",
      "bulkKycThreshold": "Bulk-KYC access threshold"
    },
    "ipAutoblock": {
      "legend": "IP auto-block — automatic block thresholds",
      "violationCount": "Violations",
      "windowHours": "Within (hours)",
      "blockHours": "Block duration (hours)"
    },
    "dualApproval": {
      "legend": "Dual approval — thresholds",
      "refundUsd": "Refund (USD)",
      "creditMemoUsd": "Credit memo (USD)",
      "bulkActionCount": "Bulk action (record count)"
    },
    "saveBar": {
      "version": "Version: {{version}}",
      "savedAt": "Saved at {{time}}",
      "save": "Save changes",
      "saving": "Saving..."
    },
    "ipList": {
      "title": "IP blacklist / whitelist",
      "tabAria": "IP list type",
      "blacklist": "Blacklist",
      "whitelist": "Whitelist",
      "addLabel": "Add to {{type}}",
      "adding": "Adding...",
      "cidrLabel": "IP / CIDR",
      "cidrPlaceholder": "e.g. 192.168.1.0/24",
      "reasonLabel": "Reason",
      "requiredError": "Please enter both IP/CIDR and reason.",
      "addErrorFallback": "Could not add IP.",
      "column": {
        "cidr": "IP / CIDR",
        "reason": "Reason",
        "addedBy": "Added by",
        "addedAt": "Added at",
        "violations": "Violations",
        "actions": "Actions"
      },
      "loading": "Loading...",
      "emptyTab": "No IPs in {{type}} yet.",
      "remove": "Remove",
      "removeConfirm": "Remove {{ip}} from {{type}}?"
    },
    "blockedIps": {
      "title": "Currently auto-blocked ({{count}})",
      "loading": "Loading...",
      "empty": "No IPs are currently auto-blocked.",
      "column": {
        "cidr": "IP / CIDR",
        "reason": "Reason",
        "blockedAt": "Blocked at",
        "expiresAt": "Expires",
        "violations": "Violations",
        "actions": "Actions"
      },
      "unblock": "Unblock",
      "unblockConfirm": "Unblock {{ip}}?"
    }
  },
  "products": {
    "wizard": {
      "step": {
        "logistics": {
          "title": "Logistics",
          "description": "Declare weight + dimensions + per-service shipping fees per SKU",
          "column": {
            "weight": "Weight",
            "length": "Length",
            "width": "Width",
            "height": "Height"
          },
          "unit": {
            "gram": "g",
            "kilogram": "kg",
            "oz": "oz",
            "lb": "lb",
            "centimeter": "cm",
            "inch": "in",
            "millimeter": "mm"
          },
          "applySelected": {
            "weight": "Apply weight to selected rows",
            "dimensions": "Apply dimensions to selected rows"
          },
          "bulkEditWeight": "Bulk Edit Weight",
          "bulkEditDimensions": "Bulk Edit Dimensions",
          "bulkEditDimensionsUnit": "Unit",
          "bulkEditApply": "Apply",
          "bulkEditCancel": "Cancel",
          "bulkEditAffects": "Applies to {{count}} selected rows",
          "clearSelected": "Clear values on selected rows",
          "unitConvertHint": "Units converted server-side to grams + cm"
        }
      }
    },
    "productionType": {
      "printing": "Printing",
      "embroidery": "Embroidery",
      "cutting": "Cutting",
      "blank": "Blank"
    },
    "techniques": {
      "section": {
        "cutting": {
          "title": "Cutting methods",
          "description": "Per-area cutting pricing deferred to MVP-C"
        },
        "blank": {
          "title": "Blank products",
          "description": "Plain products with no print / embroidery areas"
        }
      }
    },
    "validation": {
      "logistics": {
        "weightRequired": "Weight required to activate the blueprint",
        "dimensionRequired": "Dimensions (L/W/H) required to activate",
        "incompleteForActive": "SKUs missing logistics: {{skus}}"
      }
    },
    "templateCanvas": {
      "bandLabel": "Canvas editor",
      "noArea": "No area in this validation rule — add one to start editing regions.",
      "footerCancel": "Cancel",
      "footerSave": "Save changes",
      "footerSaving": "Saving…",
      "cancelConfirmTitle": "Discard unsaved changes?",
      "cancelConfirmBody": "You have unsaved edits. Leaving this page will lose them.",
      "cancelConfirmYes": "Discard",
      "cancelConfirmNo": "Keep editing"
    }
  },
  "chrome": {
    "profileDropdown": {
      "account": "My account",
      "preferences": "Preferences (Theme / Language / TZ)",
      "sessions": "Sessions",
      "shortcuts": "Keyboard shortcuts",
      "logout": "Log out",
      "shortcutCommandPalette": "Open Command Palette",
      "shortcutNotifications": "Open notifications",
      "shortcutsComingSoon": "The full list will be added in a later wave.",
      "logoutConfirm": "Are you sure you want to log out of the admin account?",
      "cancel": "Cancel",
      "logoutConfirmAction": "Log out",
      "toggleSidebar": "Toggle sidebar",
      "close": "Close"
    },
    "notificationBell": {
      "filters": {
        "all": "All",
        "orders": "Orders",
        "products": "Products",
        "stores": "Stores",
        "system": "System"
      },
      "timeAgo": {
        "justNow": "just now",
        "minutes_one": "{{count}} minute ago",
        "minutes_other": "{{count}} minutes ago",
        "hours_one": "{{count}} hour ago",
        "hours_other": "{{count}} hours ago",
        "days_one": "{{count}} day ago",
        "days_other": "{{count}} days ago"
      },
      "title": "Notifications",
      "markAllRead": "Mark all as read",
      "empty": "No notifications yet.",
      "viewAll": "View all notifications",
      "viewDetail": "View detail →",
      "markReadError": "Couldn't mark as read. Please try again.",
      "markAllReadError": "Couldn't mark all as read. Please try again.",
      "reloadPrompt": "A new version is available — please refresh your browser.",
      "forbidden": {
        "title": "Notifications unavailable",
        "body": "You don't have access to a notification feed right now.",
        "retry": "Retry"
      }
    },
    "impersonationBanner": {
      "roles": {
        "merchantOwner": "Merchant owner",
        "merchantStaff": "Merchant staff",
        "vendorOwner": "Vendor owner",
        "vendorStaff": "Vendor staff"
      },
      "viewingAs": "Viewing as {{name}} ({{role}}).",
      "stopAria": "Exit impersonation mode",
      "readonlyMode": "Read-only mode",
      "writeMode": "Write mode (5 min)",
      "stop": "Exit"
    },
    "languageSelector": {
      "selectLanguage": "Select language"
    },
    "banners": {
      "realtime": {
        "connected": "Realtime reconnected",
        "reconnecting": "Reconnecting to realtime…",
        "attempt": "Attempt #{{attempt}}",
        "retryIn": "Retrying in {{sec}}s",
        "retryNow": "Retry now",
        "disconnected": "Realtime disconnected — data may not update instantly",
        "disconnectedHint": "Check your network or click \"Retry now\" to reconnect manually."
      },
      "announcement": {
        "priority": {
          "critical": "Critical",
          "high": "Important",
          "medium": "Notice",
          "low": "News"
        },
        "positionAria": "Banner {{current}} / {{total}}",
        "prevAria": "Previous banner",
        "nextAria": "Next banner",
        "dismissAria": "Dismiss this announcement"
      },
      "dualApproval": {
        "pending": "Action requires dual approval"
      }
    },
    "timezoneSelector": {
      "selectTimezone": "Select timezone",
      "zone": {
        "vietnam": "Vietnam",
        "usEastern": "US Eastern",
        "usPacific": "US Pacific",
        "unitedKingdom": "United Kingdom",
        "japan": "Japan",
        "germany": "Germany",
        "australia": "Australia",
        "china": "China"
      },
      "searchPlaceholder": "Search timezone…",
      "noMatch": "No timezone matches",
      "searchHint": "Search to pick any other timezone"
    }
  },
  "ui": {
    "blueprintMultiSelect": {
      "selected_one": "{{count}} selected",
      "selected_other": "{{count}} selected",
      "rangeHint": "(need {{min}}-{{max}})",
      "minHint": "(minimum {{min}})",
      "maxHint": "(maximum {{max}})",
      "atMax": "Maximum {{max}} reached",
      "noMatch": "No matching blueprint.",
      "change": "Change",
      "resolving": "Loading…"
    },
    "merchantMultiSelect": {
      "rangeHint": "(need {{min}}–{{max}})",
      "searchPlaceholder": "Search merchants by name / email…",
      "loading": "Loading…",
      "noResults": "No results",
      "removeAria": "Remove {{name}}"
    },
    "pricingTierSelect": {
      "placeholder": "Select pricing tier",
      "loadError": "Failed to load pricing tiers: {{error}}",
      "empty": "No pricing tiers yet."
    },
    "impersonationBanner": {
      "viewingAs": "Viewing as {{name}} ({{role}}).",
      "stopAria": "Exit impersonation mode",
      "stop": "Exit",
      "readonlyMode": "Read-only mode",
      "writeMode": "Write mode (5 min)"
    },
    "backLink": {
      "back": "Back"
    }
  },
  "modals": {
    "createApprovalRequest": {
      "submitError": "Could not submit the request — please try again",
      "reasonPlaceholder": "Describe the reason in detail so the Super Admin can approve quickly (e.g. customer support ticket TK-1234 requests a refund for the $750 order)",
      "submitting": "Submitting…",
      "description": "The request will need another Super Admin/Admin to approve within 1 hour. Please provide a clear reason so the second approver can decide quickly.",
      "viewPayload": "View the payload to submit",
      "reasonLabel": "Reason (minimum 10 characters, maximum 1000)",
      "cancel": "Cancel"
    },
    "sessionExpired": {
      "title": "Your session has expired",
      "body": "For security reasons, your session has ended. Please sign in again to continue your work.",
      "returnHint": "After signing in, the system will return to the page:",
      "loginAgain": "Sign in again"
    },
    "bulkActionConfirm": {
      "reasonPlaceholder": "Describe the reason for this bulk action — it will be written to the audit log.",
      "charsNeeded_one": "Need {{count}} more character",
      "charsNeeded_other": "Need {{count}} more characters",
      "processing": "Processing…",
      "actionItems_one": "{{action}} {{count}} item",
      "actionItems_other": "{{action}} {{count}} items",
      "title_one": "{{action}} — {{count}} item",
      "title_other": "{{action}} — {{count}} items",
      "confirmPrefix": "Please confirm the action ",
      "confirmSuffix": ". Bulk actions cannot be fully undone — check the scope and reason before continuing.",
      "scopeLegend": "Scope",
      "scopeSelected_one": "Only {{count}} selected item on the current page",
      "scopeSelected_other": "Only {{count}} selected items on the current page",
      "scopeMatching_one": "All {{count}} item matching the current filter",
      "scopeMatching_other": "All {{count}} items matching the current filter",
      "reasonLabel": "Reason (audit — required, {{reasonMinLength}}–{{reasonMaxLength}} characters)",
      "approvalPrefix": "This action exceeds the threshold ({{threshold}} items) — needs",
      "approvalSuffix": "more approval(s) from another admin before execution.",
      "cancel": "Cancel"
    },
    "optimisticLock": {
      "yours": "Yours",
      "serverNewer": "Server (newer)",
      "mergeProposed": "Proposed merge",
      "saving": "Saving…",
      "saveMerge": "Save merged version",
      "conflictTitle": "Conflicting edit detected",
      "conflictBody": "Another admin changed this record while you were editing. Compare your current data with the latest version on the server and choose how to proceed.",
      "cancel": "Cancel",
      "forceOverwrite": "Overwrite (Super Admin)"
    },
    "exportFormatPicker": {
      "processing": "Processing…",
      "queueEmail": "Queue + email me",
      "downloadNow": "Download now",
      "title": "Export data — {{tableKey}}",
      "description": "Every export is watermarked with the admin name, timestamp and export ID for audit purposes. Large exports are queued and the link is sent by email.",
      "formatLegend": "Format",
      "columnsLegend": "Export columns ({{selected}}/{{available}})",
      "estimatedSizeLabel": "Estimated size: ",
      "rowsCount_one": "({{count}} row)",
      "rowsCount_other": "({{count}} rows)",
      "backgroundNotice": "File exceeds {{size}} — it will be processed in the background and the download link will be sent to your email.",
      "watermarkTitle": "Watermark notice:",
      "watermarkBody": "The export will embed the name “{{adminName}}”, timestamp and export ID into the file content for audit purposes. Do not redistribute the file outside the permitted scope.",
      "cancel": "Cancel"
    }
  },
  "notifications": {
    "center": {
      "title": "Notifications",
      "loading": "Loading…",
      "refresh": "Refresh",
      "empty": "No notifications yet.",
      "loadError": "Failed to load notifications: {{error}}",
      "filters": {
        "all": "All",
        "auth": "Auth",
        "vendor": "Vendor",
        "system": "System"
      }
    },
    "item": {
      "justNow": "just now",
      "minutesAgo_one": "{{count}} minute ago",
      "minutesAgo_other": "{{count}} minutes ago",
      "hoursAgo_one": "{{count}} hour ago",
      "hoursAgo_other": "{{count}} hours ago",
      "daysAgo_one": "{{count}} day ago",
      "daysAgo_other": "{{count}} days ago"
    }
  },
  "roleCatalog": {
    "descriptions": {
      "superadmin": "Full system access (catch-all wildcard *:*).",
      "admin": "Platform administration — module wildcards + granular billing.",
      "support": "Support team (enabled from Phase 9).",
      "saler": "Sales team (enabled from Phase 10).",
      "manager": "Merchant management (enabled from Phase 10).",
      "accountant": "Accounting — 12 financial permissions.",
      "affiliate": "Affiliate (enabled from Phase 10)."
    },
    "moduleLabels": {
      "auth": "Authentication (Auth)",
      "user": "Users",
      "team": "Team",
      "permission": "Permissions",
      "storage": "Storage",
      "survey": "Survey",
      "notification": "Notifications",
      "emergency": "Emergency",
      "billing": "Billing",
      "invoice": "Invoices",
      "legal_entity": "Legal entity"
    }
  },
  "adminMgmtApi": {
    "validation": {
      "emailInvalid": "Invalid email",
      "emailDomain": "Email must end with @printway.work",
      "nameMin": "Name must be at least 2 characters",
      "nameMax": "Name must be at most 100 characters",
      "emailDomainNotAllowed": "Email must use a company domain: {{domains}}"
    }
  },
  "apiMessages": {
    "adminUsers": {
      "validation": {
        "emailInvalid": "Invalid email",
        "emailMax": "Email must be at most 320 characters",
        "displayNameMin": "Display name must be at least 2 characters",
        "displayNameMax": "Display name must be at most 120 characters"
      }
    },
    "announcements": {
      "scheduleStartRequired": "schedule_start is required",
      "scheduleDatesInvalid": "schedule_start / schedule_end is not a valid date",
      "scheduleEndAfterStart": "schedule_end must be after schedule_start"
    },
    "featureFlags": {
      "productionToggleWarning": "This toggle affects production — a second Super Admin must approve."
    },
    "audit": {
      "networkFallback": "The network did not respond — please try again."
    }
  },
  "dashboard": {
    "merchantCredit": "Merchant credit",
    "merchantCreditSubtitle": "History, grant, edit, and revoke credit for each merchant.",
    "quickActions": "Quick actions",
    "comingSoon": "Coming soon"
  },
  "home": {
    "manageUsers": {
      "title": "Manage users",
      "description": "View, suspend, or impersonate platform members. Includes admins, merchants, and vendors."
    },
    "pendingVendors": {
      "title": "Pending vendors",
      "description": "Review applications, approve or reject vendor sign-ups with required notes."
    },
    "accountSettings": {
      "title": "Account settings",
      "description": "Update your profile, password, 2FA enrollment, and preferences."
    },
    "merchants": {
      "title": "Merchants",
      "description": "Manage merchant stores, billing, and impersonation."
    },
    "orders": {
      "title": "Orders",
      "description": "Cross-portal order monitoring and intervention."
    },
    "auditLog": {
      "title": "Audit log viewer",
      "description": "Browse business + security audit events."
    }
  },
  "shellChrome": {
    "breadcrumbAria": "Breadcrumb",
    "sidebarAria": "Sidebar",
    "topBarAria": "Top bar",
    "profileMenuAria": "User menu",
    "notificationsAria": "Notifications",
    "markAsReadAria": "Mark as read",
    "dismissAria": "Dismiss",
    "backToTop": "Back to top",
    "bulkActionBarAria": "Bulk action bar",
    "editorToolbarAria": "Editor toolbar"
  },
  "cms": {
    "i18nTabs": {
      "languageAria": "Language",
      "complete": "Complete",
      "partial": "Partial",
      "empty": "Empty"
    },
    "mediaPicker": {
      "insertImage": "Insert image",
      "dropImageAria": "Drop image here",
      "chooseFileAria": "Choose image file",
      "altPlaceholder": "Describe the image for screen readers"
    },
    "editorLayout": {
      "editorAria": "Editor",
      "sidebarAria": "Sidebar"
    },
    "rte": {
      "toolbarAria": "Rich text editor toolbar",
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "strikethrough": "Strikethrough",
      "h1": "Heading 1",
      "h2": "Heading 2",
      "h3": "Heading 3",
      "bulletList": "Bullet list",
      "orderedList": "Ordered list",
      "blockquote": "Blockquote",
      "codeBlock": "Code block",
      "link": "Link",
      "image": "Image",
      "embedVideo": "Embed video (YouTube/Vimeo)",
      "insertTable": "Insert table",
      "horizontalDivider": "Horizontal divider",
      "undo": "Undo",
      "redo": "Redo"
    }
  },
  "datatable": {
    "rows": "Rows",
    "rowsPerPage": "Rows per page",
    "exportFormatAria": "Export format",
    "paginationAria": "Pagination",
    "previousPage": "Previous page",
    "nextPage": "Next page",
    "toggleColumnsAria": "Toggle columns",
    "selectAllRowsAria": "Select all rows on this page",
    "savedViewsAria": "Saved views",
    "deleteSavedViewConfirm": "Delete saved view \"{{name}}\"?",
    "defaultBadge": "Default",
    "dragToReorderAria": "Drag to reorder column",
    "expand": "Expand",
    "filter": {
      "anyOption": "Any",
      "yesOption": "Yes",
      "noOption": "No",
      "hideFilters": "Hide filters",
      "moreFilters": "More filters ({{count}})",
      "clearFilters": "Clear ({{count}})"
    },
    "firstPage": "First page",
    "lastPage": "Last page",
    "showingRange": "Showing {{from}}-{{to}} of {{total}}",
    "pageOfCount": "Page {{page}} of {{total}}",
    "pageAria": "Page {{page}}"
  },
  "cmdk": {
    "paletteLabel": "Command palette",
    "searchPlaceholder": "Search merchants, vendors, orders, stores, pages…",
    "kbdHintsAria": "Command palette keyboard shortcuts"
  },
  "suspendDialog": {
    "suspendReasonPlaceholder": "e.g. Suspected fraudulent activity — pending investigation",
    "reactivateReasonPlaceholder": "e.g. Identity verified — false-positive flag"
  },
  "versionBanner": {
    "updateAvailable": "A new version is available{{versionSuffix}} — please refresh your browser to use the latest version.",
    "autoRefreshIn": "Auto-refresh in",
    "refreshNow": "Refresh now"
  },
  "_vgBinding": "vg-binding: P8.1.1.D-15 — datatable.defaultBadge label for the ColumnToggle Default badge, added across en/vi/fr [task-11]"
}
